
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/AuthService";
import * as Actions from "../../reducers/actions";
import { Tabs,Spin, Icon } from 'antd';
import { parse } from 'qs'
import {
  Redirect
} from "react-router-dom";
import {  Link, } from "react-router-dom";
import Xpage6ef04dc07 from "./xpage6/ef04dc07";
import Xpage6ef04dc08 from "./xpage6/ef04dc08";
import Xpage6ef04dc09 from "./xpage6/ef04dc09";
import Xpage6ef06dc11 from "./xpage6/ef06dc11";
import Xpage6ef04dc17 from "./xpage6/ef04dc17";
import Config from "../../config";
import {objSearch} from "../../utils/func";
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;

class XMain3 extends Component {
  constructor(props) {
    super(props);
    this.state = {prog_id:''};
    const query = this.props.location && this.props.location.search?parse(this.props.location.search.substr(1)):{}
    setTimeout(()=>{

            this.setState({ prog_id:query.prog_id});
        
    },100)
  }

 xRegister1(){
 
        return <div>
                <h1>ลงทะเบียนขอใช้ระบบการส่งรายงานการจัดการพลังงานทางอิเล็กทรอนิกส์</h1>
                <div>
                  {/* <form method="post" name="TestKey"> */}
                      <table style={{backgroundColor:'#F4D4F4'}}>
                        <tbody>
                          <tr>
                            <th align="left">TSIC-ID ของสถานประกอบการท่าน&nbsp;</th>
                            <td style={{textAlign:'left'}}><input type="text" className="textbox" name="tsic_id" size="5" value=""/>&nbsp;-&nbsp;
                                <input type="text" className="textbox" name="id_no" size="4" value=""/>
                            </td>
                          </tr>
                        <tr>
                          <th align="left">รหัสลงทะเบียนที่ได้รับจาก พพ.&nbsp;</th>
                          <td>
                            <input type="text" className="textbox" name="passkey" size="50"/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br/>
                        <p style={{textAlign:'center'}}>
                        <button type="buttom" onClick={()=>{
                             this.setState({ prog_id:'ef060c18'});
                        }}>ยืนยัน</button>&nbsp;&nbsp;
                        <button type="reset">ยกเลิก</button>
                      </p>
                      {/* </form> */}
                      </div>
               </div>
    }


    ef060c18(){
        return <div>
                <h1>แบบลงทะเบียนขอใช้ระบบ E-Form</h1>
                <div>
                  
                  <div>
                      <table>
                          <tbody>
                            {/* <tr>
                              <td></td>
                              <td>
                                <input type="hidden" name="REQ_ID" value=""/>
                                <input type="hidden" name="REQ_TYPE" value="2"/>
                              </td>
                            </tr> */}
                          <tr>
                            <td width="250px">เลขที่ใบอนุญาต</td>
                            <td style={{textAlign:'left'}} id="P_ID">น.0053</td>
                          </tr>
                          <tr>
                            <td>ชื่อผู้ได้รับใบอนุญาต&nbsp;&nbsp;</td>
                            <td style={{textAlign:'left'}}id="ORGANIZE_NAME">บริษัท วัชรากร มาเนจเมนต์ จำกัด</td>
                          </tr>
                          <tr>
                            <td>วันที่ยื่นแบบคำขอ</td>
                            <td style={{textAlign:'left'}}><input type="textbox" name="REQ_D" className="textbox" value="" size="10" maxlength="10"/>
                                <a name="REQ_D_popup" href="javascript:ShowCalendar('REQ_D','ddmmyyyy',true,24)">
                                <img src="images/Calendar.png" width="16" height="16" border="0" alt="Pick a date"/>
                                </a>
                            </td>
                          </tr>
                          <tr>
                            <td>ผู้ยื่นแบบคำขอ*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="REQ_BY" className="textbox" value="" size="50" maxlength="50"/>&nbsp; 
                              <i><u>ตัวอย่าง</u>&nbsp;นางสาวมานี มีใจดี</i>
                            </td>
                          </tr>
                          <tr>
                            <td>โทรศัพท์ติดต่อ*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="TEL" className="textbox" value="" size="40" maxlength="40"/>&nbsp; 
                              <i>ไม่ต้องใส่เครื่องหมายใดๆ โดยมีรูปแบบดังตัวอย่าง 029994444 หรือ 0819876543</i>
                            </td>
                          </tr>
                          <tr>
                            <td>โทรสาร</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="FAX" className="textbox" value="" size="40" maxlength="40"/>&nbsp; 
                              <i>ไม่ต้องใส่เครื่องหมายใดๆ โดยมีรูปแบบดังตัวอย่าง 029994444</i>
                              </td>
                          </tr>
                          <tr>
                            <td>อีเมล*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="EMAIL" className="textbox" value="" size="40" maxlength="50"/>
                            </td>
                          </tr>
                          <tr>
                            <td><b>ผู้บันทึกข้อมูล</b></td><td>&nbsp;</td>
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-ชื่อ-นามสกุล*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="ACCOUNT_NAME" className="textbox" value="" size="40" maxlength="50"/>&nbsp;
                              <i><u>ตัวอย่าง</u>&nbsp;นายสุดฤทธิ์ สุดเดช</i>
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-เป็นชาวต่างชาติ*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="radio" name="FOREIGNER" className="radio" onchange="ef060c18_foreigner(this)" value="1"/>ใช่
                              <input type="radio" name="FOREIGNER" className="radio" onchange="ef060c18_foreigner(this)" value="" checked=""/>ไม่ใช่&nbsp;
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-เลขที่บัตรประชาชน/Passport ID*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="ID_CARD" className="textbox" value="" size="13" maxlength="50"/>&nbsp; 
                              <i>ไม่ต้องใส่เครื่องหมายใดๆ ในเลขบัตรประชาชน</i>
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-ออกโดยประเทศ</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="COUNTRY" className="textbox" value="" disabled="" size="30" maxlength="50"/>&nbsp; 
                              <i>เฉพาะชาวต่างชาติเท่านั้น</i>
                            </td>
                          </tr>
                          <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-อีเมล*</td>
                            <td style={{textAlign:'left'}}>
                              <input type="textbox" name="USER" className="textbox" value="" size="40" maxlength="50" onchange="ef060c18_user(this)"/>&nbsp;
                              <i>(ใช้สำหรับล็อกอินเข้าสู่ระบบ)</i>
                            </td>
                          </tr>
                          <tr>
                            <td></td><td id="PERMIT_ID"><input type="hidden" name="PERMIT_ID" value="น.0053"/></td>
                          </tr>
                          <tr>
                            <td colspan="2" align="left">
                                  <br/>
                                  <font color="#FF0000"><u>หมายเหตุ</u> ชื่อ และ อีเมลที่ระบุระบบจะตรวจสอบ จะต้องไม่เคยใช้ลงทะเบียนในฐานะอื่นๆ เช่นผู้ตรวจสอบที่ได้รับใบอนุญาตอื่น หรือโรงงานควบคุมและอาคารควบคุมอื่นมาก่อน<br/>มิฉะนั้นการลงทะเบียนจะไม่สมบรูณ์</font>
                            </td>
                          </tr>
                        </tbody>
                        </table>
                    </div>





                        <p style={{textAlign:'center'}}>
                        <button type="buttom" onClick={()=>{
                            //  this.setState({ prog_id:'ef060c18'});
                        }}>ยืนยัน</button>&nbsp;&nbsp;
                        <button type="reset" onClick={()=>{
                             this.setState({ prog_id:'xRegister1'});
                        }}>ยกเลิก</button>
                      </p>

                      </div>
               </div>
    }
  render() {
      let { prog_id } = this.state

    return <div className="App">
       {
          prog_id == 'xRegister1'?
          this.xRegister1()
          :null
       }
      {
          prog_id == 'ef060c18'?
          this.ef060c18()
          :null
       }
       
      </div>;
  }
}
function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(XMain3);
// export default Singin;


// WEBPACK FOOTER //
// ./src/view/main/xpage3.js